<template>
<v-container grid-list-md>    
    <v-layout column>
        <v-flex>
            <v-layout row>
                <v-flex xs6>
                    <forecasting-profile-edit :crop="crop" :variety="variety" :forecasts="forecasts"></forecasting-profile-edit>
                </v-flex>
                <v-flex xs1 v-if="!$vuetify.breakpoint.smAndDown">
                    <v-divider vertical class="noteCenterDivider"></v-divider>
                </v-flex>
                <v-flex xs6 v-if="!variety.activeProfile.BerriesForecastProfileID">
                    <v-alert type="error" :value="true">
                        <span>Error: No active profile set for location and variety!</span>
                    </v-alert>
                </v-flex>
                <v-flex v-else xs6>
                    <forecasting-profile-budget-list :financialYearCalendars="financialYearCalendarData" :variety="variety"></forecasting-profile-budget-list>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex>
            <v-layout row wrap>
                 <v-flex xs12>
                        <v-alert :value="error"
                        outline
                        type="error">
                        {{error}}
                    </v-alert>
                </v-flex>
                <v-flex xs6>
                    <v-btn color="secondary" dark block @click="$emit('goBack')">Close</v-btn>
                </v-flex>
                <v-flex xs6>
                    <v-btn color="primary" block @click="save()" :loading="saving">Save</v-btn>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex v-if="variety.activeProfile.BerriesForecastProfileID">
            <v-radio-group v-model="displayValueTypeCode" row class="align-center justify-center">
                <v-radio v-for="(valueTypeCode, i) in valueTypeCodes" :key="`valueTypeCode${i}`" :label="valueTypeCode.text" :value="valueTypeCode.value"></v-radio>
            </v-radio-group>
            <forecasting-profile-production-curve :financialYearCalendars="financialYearCalendarData" :cropProfile="variety.activeProfile" 
                :displayValueTypeCode="displayValueTypeCode" :loading="graphLoading" :cropForecasts="forecasts">
            </forecasting-profile-production-curve>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import ForecastingProfileProductionCurve from '@/components/forecasting/forecastingProfile/ForecastingProfileProductionCurve.vue';
import ForecastingProfileBudgetList from '@/components/forecasting/forecastingProfile/ForecastingProfileBudgetList.vue';
import ForecastingProfileEdit from '@/components/forecasting/forecastingProfile/ForecastingProfileEdit.vue';

import forecastingUtilService from '@/services/forecastingUtilService';
import moment from 'moment';

import { mapState, mapActions } from "vuex"

export default {
    components: {
        ForecastingProfileProductionCurve,
        ForecastingProfileBudgetList,
        ForecastingProfileEdit
    },
    props: {
        variety: {
            type: Object,
            required: true
        },
        forecasts: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            error: null,
            saving: false,            
            graphLoading: false,
            displayValueTypeCode: "kg",
            valueTypeCodes: [{
                    text: "Percentage (%)",
                    value: "%"
                },
                {
                    text: "Kilograms (kg)",
                    value: "kg"
                }
            ],
        };
    },
    computed: {
        ...mapState("ForecastingStore", [
            "financialYearCalendarData",
            "crops"
        ]),
        crop(){
            return this.crops.find(x => x.cropLocationId == this.variety.cropLocationId)
        },
        totalBudgetPercentage() {
            let total = 0;

            this.variety.activeProfile.BudgetValues.forEach(item => {

                total += (item.BudgetValue * 100);
            });

            return Math.round(total * 10)/10;
        }
    },
    methods: {
        ...mapActions("ForecastingStore", [
            "handleCropVarietyChanged",
            "updateData"
        ]),
        async save() {
            this.error = null;

            if (this.variety.activeProfile.BudgetValues && this.totalBudgetPercentage !== 100) {
                this.error = "Curve % should always total 100%";
                return;
            }

            if (this.variety.manualNextPickDate && moment(this.variety.manualNextPickDate).add(this.variety.rotationDays || 0,'days') < moment()) {
                this.error = "Next Pick Date must be in the future";
                return;
            }

            if (this.variety.activeProfile.BerriesForecastProfileID) {
                let profileStartDate = forecastingUtilService.getFinancialStartDateFromProfile(this.variety.activeProfile, this.financialYearCalendarData);

                if (moment(profileStartDate) < moment(this.crop.cropStartDate) || moment(profileStartDate) > moment(this.crop.cropEndDate)) {
                    this.error = `Profile start date must fall inside of Crop Start: ${moment(this.crop.cropStartDate).format("YYYY-MM-DD")} and Crop End: ${moment(this.crop.cropEndDate).format("YYYY-MM-DD")}`;
                    return;
                }
            }

            this.saving = true;

            await this.handleCropVarietyChanged(this.variety);
            await this.updateData();

            this.$emit("goBack");
        }
    },
    async created() {

    }
}
</script>